// Entities
import { IPopupOptions } from "./entities";

export class Popup {
  public _component: any = void 0;

  constructor(
    public title: string,
    public message: string,
    public options?: IPopupOptions
  ) {}

  public close(action: any): void {
    this._component.instance.doAction(action);
  }
}
